<template>
    <div>


<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>



    <v-snackbar
      v-model="mensaje2.snackbar"
      :timeout="mensaje2.timeout"
      :color2="mensaje2.color"
      text
      top
      right
    >
      {{ mensaje2.text }}

      <template v-slot:action="{ attrs }">

          <v-btn
      v-if="!usuario.email_verified_at"
      color="warning"
      class="mr-4"
      :disabled="false"
      @click="verificarCorreo()"
    >
    <v-icon class="ma-1">
      mdi-email
    </v-icon>
      Verificar


          </v-btn>
<v-btn
          :color="mensaje2.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje2.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>



  <!-- <div class="my-2">
      <v-btn @click="dialog = true">check data</v-btn>
    </div> -->

     <v-dialog
      v-model="dialog"
    >
      <v-card>
    
        {{zoom}}

        <v-card-title>USUARIO
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-title>
          <v-card-text class="pprint">{{ usuario }}</v-card-text>

        <v-card-title>PRINCIPAL </v-card-title>


        
       <v-card-text class="pprint">{{ principal }}</v-card-text>

        <v-card-title>OPCIONES </v-card-title>
        <v-card-text class="pprint">{{ pprint }}</v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  <v-container>

  

      <v-row >
          <!-- inicio vrow principal -->




 <v-col cols="1"> 
                <v-row >
                    <v-col cols="12">
                 <PrincipalImg    :principalData="principal"   @principalEditImg="recibirPrincipalImg"></PrincipalImg>

 
                 </v-col>

                 <v-col>
                 
                  <PrincipalColor    :principalData="principal"   @principalEdit="recibirPrincipal"></PrincipalColor>
               
                </v-col>

                 </v-row>


                 
                 </v-col>




         <v-col
          cols="10" sm="10" lg="10"
        >
<v-card
  elevation="9"

 

>
      


<v-row>
    <!-- Columna para la imagen -->
    <v-col
      cols="12"  sm="12" md="3"  lg="3"
        class="d-flex justify-center"
    >
      <v-avatar 
      
      size="20vh"
      
      class="ma-0"
      >

        <a data-fancybox data-caption="Single image" :href="server_url+'api/principal/get_image/'+principal.identificador+'/'+ principal.linkPhoto">
          
        
          <img 
          
         
          :src="server_url +'api/principal/get_image/'+principal.identificador+'/'+principal.linkPhoto"
          
          :style="{
    height: '20vh',
    transform: 'scale(' + this.principal.zoom / 50 + ') translate(' + principal.fotox + 'px,' + principal.fotoy + 'px)',
    transition: 'transform 0.2s'
  }"


           />
        </a>
          
      </v-avatar>
    </v-col>

    <!-- Columna para el texto -->
    <v-col
      cols="12" sm="12" md="9" lg="9"
      align-self="center"
    >
      <v-card-title 

      :style="{
                fontSize: '30px',   /* Tamaño */
                fontWeight: '500',   /* Peso */
                letterSpacing: '-.015625em', /* Espaciado */
              /*  marginBottom: active ? '-1rem' : '0', /* Margen dinámico */
                color: principal.color
              }"
      
      class="mt-0 pt-0  mb-3 ml-200">{{ principal.nombre }} {{ principal.apellido }}</v-card-title>
      
      <v-card-title  
      :style="{
                fontSize: '200',   /* Tamaño */
                fontWeight: '500',   /* Peso */
                letterSpacing: '-.015625em', /* Espaciado */
             /*   marginBottom: active ? '-1rem' : '0', /* Margen dinámico    grey--text en la parte de class de abajo*/
                color: principal.color
              }"
      

      
      class="mt-0 pt-0   mb-1  ml-200" 
      >{{ principal.descripcion }}</v-card-title >

      <v-divider   class="mx-4"
      :style="{ backgroundColor: principal.color}"
      
      ></v-divider>
    </v-col>
  </v-row>


    <v-card-actions>

      



      <v-row justify="end" >


        <v-col cols="12"  sm="12" lg="2" md="2"  class="mb-5 pb-5">

        <v-btn outlined text color="blue darken-4" 
      v-if="usuario.email_verified_at"
            @click="copiarUrl()"
            >

            <v-icon>
       mdi-link
      </v-icon> 
              Copiar URL
            </v-btn>


          </v-col>

          <v-spacer></v-spacer>

        <v-col cols="12"  sm="12" lg="2" md="2"  class="mb-5 pb-5">

         

          <v-btn
      v-if="!usuario.email_verified_at"
      color="warning"
      class="mr-4"
      :disabled="false"
      @click="perfilNotificacion()"
    >
      Ir a Perfil
    </v-btn>
    <v-btn
    
      v-else
      color="success"
      class="mr-4"
      @click="perfilOpen(principal.identificador)"
      target="_blank"
    >

    <v-icon>
       mdi-open-in-new
      </v-icon> 
   <div> </div>
        Ir a Perfil
    </v-btn>

        </v-col>

        <v-col cols="12"  sm="12" lg="3" md="3"  class="mb-5 pb-5">



        </v-col>

<v-col cols="12"  sm="12" lg="3" md="3">
        <OpcionDialogAddGeneral :principalData="principal"   @opcionEdit="recibirOpcion"></OpcionDialogAddGeneral>
 </v-col>
        


        <v-col cols="1">

        </v-col>

      </v-row>
  
    </v-card-actions>

</v-card>

         

     
   
    </v-col>

    <v-col cols="1">

      <v-row>

          <v-col cols="12">
            <PrincipalEditDialog   :principalData="principal"   @principalEdit="recibirPrincipal"></PrincipalEditDialog>

          </v-col>

      </v-row>


    </v-col>


    

      </v-row>   
      <!-- fin vrow principal -->

      
    </v-container>


   

<!-- inicio opciones de link -->


<!-- <v-container > -->
  <!--   <v-row   d-flex        flex-no-wrap  >

         <v-col cols="10">

        </v-col>

 <v-col cols="2">

                <OpcionDialogAddGeneral :principalData="principal"   @opcionEdit="recibirOpcion"></OpcionDialogAddGeneral>

              </v-col> 

      </v-row> -->

<!-- </v-container>   :key="i"-->


    <v-container >
      <v-row   d-flex        flex-no-wrap  >  

        <v-col cols="1">
                            <!-- espacio para hacer scroll en movil -->

  </v-col> 

  <v-col cols="10">
           

<div id="dragTable">

  

        <v-col cols="12"
        
         v-for="(opcion) in opcions"
         
           :key="itemKey(opcion)" 
        
          
            class="sortableRow sortHandle handle"
        >

      <v-row >

              <v-col cols="1"> 
                <v-row >
                    <v-col cols="12">
                  <!-- <OpcionImg    :opcionData="opcion"   @opcionEditImg="recibirOpcionImg"></OpcionImg> -->


                  <OpcionIcon    :opcionData="opcion"   @opcionEditIcon="recibirOpcionIcon"></OpcionIcon>

                    
                 </v-col>

                 <v-col cols="12">
                       
                       <OpcionColor    :opcionData="opcion"   @opcionEditColor="recibirOpcionColor"></OpcionColor>
                       
                               </v-col>

                 </v-row>
                 </v-col>





        <v-col
         
          cols="10" sm="10" lg="10"
        >
          <v-card
            :color="opcion.color"
            dark

          >
            
                  <!-- justify="space-between"     no-gutters                   align="center" align-content="center"     d-flex        flex-no-wrap       justify-space-between  -->
              <template>
               <v-container>
      <v-row 
      no-gutters
       >
              <v-col 
            
        cols="12"
        sm="12"
        md="2"
        lg="2"
      
              
              >


            <v-avatar
              
                class="ma-3"
                size="100"
                tile
>
  <!-- <a data-fancybox data-caption="Single image" :href="server_url+'api/imagenes_base/get_imagenes_base/'+ opcion.linkPhoto"> -->
        <img :src="server_url +'api/imagenes_base/get_imagenes_base/'+opcion.linkPhoto" style="height:100px" />
      <!-- </a> -->

    </v-avatar> 

                  
             </v-col>




      
                  <v-col 
                    
                   cols="12"
                   sm="12"
                   md="8"
                    lg="8"
      class="pl-4"
                  >
                 

                <v-card-title
                  class="text-h5"
                                    

                > {{opcion.descripcion}} - Order {{ orderNumber(opcion) }}</v-card-title>

                <v-card-subtitle>
                  {{opcion.observacion}}
                </v-card-subtitle>


            
                <v-card-actions >
        
        
        <v-row  >

        <v-col cols="10">
                    
                  <template>


                       
                       
                      <v-row>

                        <v-col cols="10">
                  <OpcionColorBtn    :opcionData="opcion"   @opcionEditColorBtn="recibirOpcionColorBtn"></OpcionColorBtn>
                    </v-col>

                    <v-col cols="10">
                  <v-btn
                     x-large
                     block
                     style="padding: 5px;"
                     
                    :color="opcion.colorBtn"

                    :href="opcion.link"
                      target="_blank"
                     
                     
                  >

                   <v-icon>mdi-open-in-app</v-icon>
                   <v-spacer></v-spacer>
                    OPEN LINK

                      
                    <v-spacer></v-spacer>
                       
                      
                               
                  </v-btn>
                </v-col>

                
                  </v-row>
                  

                 

                  </template>

        </v-col>

        </v-row>

                </v-card-actions>

               
              </v-col>


             

                
              



              </v-row>
               </v-container>
              </template>
         
          </v-card>

          


           




        </v-col>

        

        <v-col cols="1">
<!-- <v-card> -->
            <v-container> 
                <v-row >

    <!-- <OpcionRegisterDialog :principalData="principal"   @opcionEdit="recibirOpcion"></OpcionRegisterDialog> -->
                 



                   <v-col cols="12" >
                  <OpcionDialogEdit :opcionData="opcion"   @opcionEdit="recibirOpcion"></OpcionDialogEdit>

                 </v-col>

                 <v-col cols="12">
                        <button @click="eliminarOpcion(opcion)" 
                       icon
                      class="m-0" 
                        ><v-icon>mdi-delete-forever</v-icon></button>

                  </v-col>

        <v-col cols="12">
                  
                     

                </v-col>
        
                </v-row>
            </v-container>

          <!-- </v-card> -->
            </v-col>

            
         
      </v-row>

        </v-col> 
        <!-- fin col 12 -->


              </div>  
               <!-- fin dragable -->

              </v-col>


              <div cols="1">


              </div>


      </v-row>
    </v-container>


<!-- fin de opciones de link -->

  </div>
</template>


<script>


import Sortable from 'sortablejs';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import { http } from "@/services/config";

import principalService from "@/services/principalService.js";

import usuarioService from "@/services/usuarioService.js";


import opcionService from "@/services/opcionService.js";

import axios from 'axios';

import PrincipalDialog from '../principal/PrincipalDialog';

import PrincipalOpcion from '../principal/PrincipalOpcionDialog.vue';

import PrincipalRegisterDialog from '../auto_register/PrincipalRegisterDialog';

import PrincipalColor from '../auto_register/principal/PrincipalColor';


import PrincipalEditDialog from '../auto_register/principal/PrincipalEditDialog';

import OpcionColor from '../auto_register/OpcionColor';

import OpcionColorBtn from '../auto_register/opcion/OpcionColorBtn';

import OpcionImg from '../auto_register/opcion/OpcionImg';

import OpcionIcon from '../auto_register/opcion/OpcionIcon';

import PrincipalImg from '../auto_register/principal/PrincipalImg';

import OpcionDialogEdit from '../auto_register/OpcionDialogEdit';

import OpcionRegisterDialog from '../auto_register/OpcionRegisterDialog';
import OpcionDialogAddGeneral from '../auto_register/opcion/OpcionDialogAddGeneral';

import loginService from "@/services/loginService.js";

export default {


     name: 'PrincipalRegister',
    
  components: {
   PrincipalDialog,
   PrincipalOpcion,
   PrincipalRegisterDialog,
   PrincipalColor,
   PrincipalEditDialog,
   OpcionDialogEdit,
   OpcionRegisterDialog,
   OpcionDialogAddGeneral,
   OpcionColor,
   OpcionColorBtn,
   OpcionImg,
   OpcionIcon,
   PrincipalImg
  },
    data: vm => ({

      tokenObject:{
          recaptcha:''
      },

       mensaje2:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },

      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },


       imageUrl: null,
    dialog: false,
    itemKeys: new WeakMap(),
    currentItemKey: 0,
   
    zoom: 50,
      archivo: null,
      fileData: {
        url: "",
        name:""
      },
       server_url: "",
      usuario:{
      id:'',
      name:'',
      identificador:'',
      email:'',
      password:''
              },
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  principals: [],
        principal:{

id:'',
nombre:'',
apellido:'',
identificador:'',
descripcion:'',
linkPhoto:'',
observacion:'',
linkVideo:'',
zoom:50,
fotox:0,
fotoy:0,
//color:'#FFFFFF', //COLOR POR DEFECTO
          
        },

         opcions: [],
        opcion:{
id:'',
descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
color:'',
observacion:'',
linkVideo:'',
imagenesBase:{
id:'',
descripcion:'',
tipo:'',
linkPhoto:'',
icon:''
        }  
        },
        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
  }),
  created(){

       }
  ,mounted(){

       new Sortable(
      document.querySelector('#dragTable'),
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder
      }
    )

  this.getUserPorIdentificador(this.$route.params.identificador);





  Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });



     this.server_url = http.defaults.baseURL;


     this.opcion.imagenesBase= { "id": 8, "descripcion": "defecto", "tipo": "redes", "linkPhoto": "1718291867-link.png", "icon": "mdi-account", "created_at": "2024-06-13T15:17:30.000000Z", "updated_at": "2024-06-13T15:17:30.000000Z"}
      

    // console.log(this.principal.zoom);
    // if(!this.principal.zoom){

    //  console.log("Ingrese en inicializar zoom");
    //  this.principal.zoom=50;
    // }

    


    },

  methods: {

    copiarUrl(){

      let iden=localStorage.getItem("identificador");

      const url = this.$router.resolve({ path: `/perfil/${iden}` }).href;

  navigator.clipboard.writeText(window.location.origin+url)
    .then(() => {
     

      this.mensaje2.snackbar=false;
       

   let mensajeText = 'URL copiada exitosamente, puede agregar en la descripción de sus redes';


        this.mensaje.text=mensajeText;

        this.mensaje.color="primary";
 this.mensaje.colorBtn="blue";

 this.mensaje.snackbar="true";

      
    })
    .catch(err => {
      console.error('Error al copiar la URL:', err);
    });




    },

    async recaptcha() {
  try {
    // Espera hasta que reCAPTCHA esté listo
    await this.$recaptchaLoaded();

    // Ejecuta la verificación con la acción "login"
    const token = await this.$recaptcha('login');

    // Asigna el token
   // this.usuario.recaptcha = token;
  //  this.tokenRe = token; // Asigna el valor a this.tokenRe si lo necesitas

    // Retorna el token para su uso posterior
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; // Lanza el error para manejarlo externamente
  }
},

  async  verificarCorreo(){

      console.log("Ver 2502");

      try {
      const token = await this.recaptcha(); // Espera hasta que recaptcha() termine


     // console.log('Token obtenido:', token);
      this.tokenObject.recaptcha=token;


    } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }

// PARA PROBAR QUE DE ERROR EL RECAPTCHA
//this.tokenObject.recaptcha="jklkjjjhhxd";

     loginService.verificarCorreo(this.tokenObject).then(
        response =>{

          this.mensaje2.snackbar=false;
       
            console.log('success');

        let mensajeText = 'Link de acceso enviado';

          mensajeText += "\n"+"Verifique su correo electrónico para finalizar la operación";

             this.mensaje.text=mensajeText;

             this.mensaje.color="primary";
      this.mensaje.colorBtn="blue";

      this.mensaje.snackbar="true";


          
        }).catch((errors) =>{
//errors.message

this.mensaje2.snackbar=false;
          let mensajeError = '';

          mensajeError += "\n"+"Error: "+errors.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
        
           console.log('error');
            console.log(errors);


           
        })





    },

    perfilNotificacion(){

      let mensajeNot = 'Verifique su correo electrónico para poder realizar la publicación';

        //  mensajeNot += "\n"+"Ir a la opción <a href="">Usuario</a>";


                this.mensaje2.text=mensajeNot;

             this.mensaje2.color="primary";
      this.mensaje2.colorBtn="blue";

      this.mensaje2.snackbar="true";


    },

     perfilOpen(identificador){

    
      //this.$router.push(`/perfil/`+identificador);

     
const url = this.$router.resolve({ path: `/perfil/${identificador}` }).href;
window.open(url, '_blank');
   

  },

    async resolverUrl() {
      try {
        const response = await axios.get(`${this.server_url}api/opcion/get_image_opcion/${this.opcion.principal_id}/${this.opcion.linkPhoto}`);
        // Suponiendo que la respuesta contenga la URL de la imagen en `data.url`
        this.imageUrl = response.data.url;
console.log("La URL");
        console.log(this.imageUrl);
      } catch (error) {
        console.error('Error fetching image URL:', error);
        this.imageUrl = null;
      }
    },
  

      itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
      return this.itemKeys.get(item)
    },
    dragReorder ({oldIndex, newIndex}) {
      const movedItem = this.opcions.splice(oldIndex, 1)[0];
      this.opcions.splice(newIndex, 0, movedItem);

      // Actualizar el atributo 'orden' de cada ítem según su nuevo índice
  this.opcions.forEach((item, index) => {
    item.orden = index + 1;


  });

//for update
  this.opcions.forEach((item, index) => {
    

     opcionService.update(item).then(
        response =>{
            console.log('success'+response.data.status);

            console.log(response);
        
        }).catch((errors) =>{
       
           console.log('error');
            console.log(errors);

           
        })


  });







  






    },
    orderNumber (item) {

      
      return this.opcions.indexOf(item) + 1
    },
    onClick () {
      this.dialog = true
    },

     zoomOut () {
        this.zoom = (this.zoom - 20) || 0
      },
      zoomIn () {
        this.zoom = (this.zoom + 20) || 200
      },
     uploadFile: function () {
      this.principal.linkPhoto=this.fileData.url;
      if (this.archivo) this.submitFile();
      else this.removeFile();
    },
    submitFile() {

      this.fileData.name=this.archivo.name;
      console.log(this.archivo);
      const formData = new FormData();
      formData.append("file_perfil", this.archivo);
      formData.append("identificador", this.principal.identificador);
      formData.append("user_id", this.usuario.id);
      const headers = { "Content-Type": "multipart/form-data" ,
      'Authorization':'Bearer '+ localStorage.getItem("token")};

      console.log(formData);
      http
        .post(this.server_url + "api/principal/save_img/", formData, { headers })
        .then((res) => {
          //res.data.files; // binary representation of the file
          //res.status; // HTTP status
         // this.fileData = res.data.principal;
      //    console.log(this.fileData.url);
         // console.log(res.data);

         this.principal.linkPhoto=res.data.principal.linkPhoto;
         this.fileData.url=res.data.principal.linkPhoto;

         console.log(this.principal.linkPhoto);
        });
    },
    removeFile() {
        this.fileData = { url: "" };
      
        this.archivo=null;

        this.principal.linkPhoto='';
  
    },

getUserPorIdentificador:function(identificador){

      usuarioService.obtenerUsuarioPorIdentificador(identificador)
        .then((respuesta) => {

          console.log(respuesta.data.user);

          this.usuario=respuesta.data.user;

          this.obtenerPrincipal(this.usuario.email);
          
        })

},
    //NO ESTA FUNCIONANDO LA RECARGA DE LA LISTA A VECES
  recibirOpcion:function(opcion){

      console.log('En elemento padre Opcion despues de editar');
   
   
      console.log(opcion);

            //ESTE NO FUNCIONA EN PRODUCCION POR QUE SERA
      //  this.listarOpcions(this.$route.params.identificador);


        setTimeout(() => {
          console.log("dentro de segunda consulta07-03");
          this.listarOpcions(this.$route.params.identificador);

        }, 500);

      //  console.log(this.$route.params.identificador);

    
 
    },
//listarPrincipalsOpcionPorIdentificadorSinVer           Cors Origin
//obtenerPrincipalPorUserPorIdentificador
     listarOpcions(identificador) {

      console.log("Ingrese a listado A");
   
      principalService   ///Este es sin necesidad de email verified
        .listarPrincipalsOpcionPorIdentificadorSinVer(identificador)
        .then((res) => {
         

          console.log("Ingrese a listado B");
  //console.log(res.data);
          console.log(res.data.principal);
          console.log(res.data.principal.opciones);

          
          this.opcions = res.data.principal.opciones;
          this.principal=res.data.principal;


          this.resolverUrl();
        })
  
  },

obtenerPrincipal(email) {
      principalService
        .obtenerPrincipalPorUserPorEmail(email)
        .then((respuesta) => {
          console.log(respuesta.data);
          console.log(respuesta.data.status);

          if(respuesta.data.status){
                  this.principal=respuesta.data.principal;

                   console.log(this.principal);

    this.listarOpcions(this.principal.identificador);


          }else{
         
         
          this.principal.nombre=this.usuario.name;
          this.principal.identificador=this.usuario.identificador;
          this.principal.color='#FFFFFF';
          this.principal.descripcion="Perfil de: "+this.usuario.name;
            console.log("No tiene una tabla principal asociado ok");


      //Automaticamente registra datos basicos para principal
            this.registrar();




          }
          
        }).catch((error) => {
        console.log(error);
        this.principal.nombre=this.usuario.name;
          this.principal.identificador=this.usuario.identificador;

            console.log("No tiene una tabla principal asociado");
        // Manejar el error aquí, si es necesario
    });
  
  },


  recibirPrincipal:function(principal){

      console.log('En elemento padre Principal Register despues de registrar/editar');
        console.log(principal);
 
    },

    recibirColor:function(color){

      console.log('En elemento padre Principal despues de elegir el color');
        console.log(color);

        this.principal.color=color;
 
    }
    ,
     recibirOpcionImg:function(img){

      console.log('En elemento padre PrincipalRegister despues de elegir la imagen');
        console.log(img);
    }
    ,
     recibirOpcionIcon:function(imagenesBase){

      console.log('En elemento padre PrincipalRegister despues de elegir el icono 3');
        console.log(imagenesBase);

        this.opcion.imagenesBase=imagenesBase;
        this.opcion.imagen_base_id=imagenesBase.id;

          console.log(this.opcion);
    },
     recibirPrincipalImg:function(img){

      console.log('En elemento padre PrincipalRegister despues de elegir la imagen de principal');
        console.log(img);
    }
    ,
     recibirOpcionColor:function(color){

      console.log('En elemento padre PrincipalRegister despues de elegir el color');
        console.log(color);
    },
    recibirOpcionColorBtn:function(colorBtn){

console.log('En elemento padre PrincipalRegister despues de elegir el color');
  console.log(colorBtn);
},
          // Utilizado solo en la primera vez de iniciar sesión.
    registrar(){
       /*   if(this.principal.codigo===""||this.principal.codigo===null){
      //Eliminar para que funcione el auto incrementable
        delete this.principal.codigo;
          }*/

        console.log(this.principal);
        this.principal.color='#000000';   //COLOR POR DEFECTO AL INICIAR NEGRO
principalService.save(this.principal).then(respuesta=>{
           //this.limpiar();

          console.log(respuesta.data);

          this.principal=respuesta.data.principal;
      
          });
    },
    editarPrincipal(principal){

    //  console.log('Editar Principal');
      
     //
     // console.log(this.principal);


     this.principal.id=principal.id;
     this.principal.id=principal.id;
     this.principal.nombre=principal.nombre;
     this.principal.apellido=principal.apellido;
     this.principal.descripcion=principal.descripcion;
     this.principal.linkPhoto=principal.linkPhoto;
     this.principal.observacion=principal.observacion;
     this.principal.linkVideo=principal.linkVideo;
     

      this.tab="one";
  
       console.log(principal);

    },
    limpiar(){

     
		this.principal={
				id:'',
				id:0,
				nombre:'',
				apellido:'',
				descripcion:'',
				linkPhoto:'',
				observacion:'',
				linkVideo:'',
	}

        
    },
  recibirPrincipal:function(principal){

      console.log('En elemento padre Redact despues de editar');
      //  console.log(principal);
 
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    recibirPrincipalOpcion:function(principalOpcion){

      console.log('En elemento padre Principal');
      //  console.log(principalOpcion);
     

    }

    ,
    eliminarOpcion(opcion){

        if(confirm('Desea remover al opcion')){
        
        opcionService.delete(opcion).then(resposta=>{

          this.listarOpcions(this.$route.params.identificador);
          this.errors=[]
          this.limpiar();

        }).catch(e=>{

          this.errors =e.response.data.errors

        })

        }


        


    },
  },

    watch: {

    /*  fileData(val){            //download uri o name
        this.principal.linkPhoto=this.fileData.name;
      }*/

      opcionEdit(newValue) {
      
        console.log("Wats 1");
     // this.opcion.colorBtn=newValue;

     this.listarOpcions(this.$route.params.identificador);
    },
    recibirOpcion(newValue) {
      
      console.log("Wats 2");
      // this.opcion.colorBtn=newValue;
 
      this.listarOpcions(this.$route.params.identificador);
     }

      
      
    },
  computed:{
    
  pprint: {
      get () { return JSON.stringify(this.opcions, undefined, 4)}
    },
    vueVersion: {
      get () { return Vue.version }
    },
    vuetifyVersion: {
      get () { return Vuetify.version }
    },
    sortableVersion: {
      get () { return Sortable.version }
    },

    	
    principalsBuscados() {
          return this.principals.filter(principal => {
            return principal.nombre.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      },

  /*    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    },
    usuario() {
      return this.$store.state.usuario;

    },*/

    sortedOpcions() {
      return this.opcions.slice().sort((a, b) => a.orden - b.orden);
    }
    
  
  },
};
</script>



<style scoped>


.handle {
  cursor: move;
}
tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.01);
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.pprint {
  white-space:pre-wrap;
  word-wrap:break-word;
}
</style>
